export default {
  docTypeManager: {
    type: {
      getFullTree: 'api/dify/docType/getFullTree',
      getTypeTree: 'api/dify/docType/getTypeTree',
      saveType: '/api/dify/docType/saveType',
      updateType: '/api/dify/docType/updateType',
      delType: '/api/dify/docType/delType',
      dynamicTree: '/api/dify/docType/dynamicTree'
    },
    question: {
      saveQuestion:'/api/dify/docQuestion/saveQuestion',
      updateQuestion: '/api/dify/docQuestion/updateQuestion',
      delQuestion: '/api/dify/docQuestion/delQuestion',
      getQuestionList: '/api/dify/docQuestion/getQuestionList'
    },
  }
}
